var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 16,
    height: 16,
    transform: "translate(1.851 1.272)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-User_Management"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Management",
    "data-name": "User Management",
    clipPath: "url(#clip-User_Management)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(-1.851 -1.272)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M9.364,7.163c-1.593,0-2.622-1.541-2.622-3.926S8.3.5,9.228.5A2.3,2.3,0,0,1,11,1.122a3.537,3.537,0,0,1,.709,2.6C11.713,5.433,10.987,7.163,9.364,7.163Z",
    transform: "translate(-1.02 2.109)",
    fill: "none",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M10.563,19.386H.5V16.924c0-1.113,1.7-2.543,3.983-2.789l.179-.019,0,.179a.917.917,0,0,0,.269.609,1.617,1.617,0,0,0,1.187.381c1.463,0,1.543-.962,1.546-1l.011-.166.165.019c.162.02,3.971.512,3.971,2.789Z",
    transform: "translate(2.109 -4.716)",
    fill: "none",
    stroke: "#585858",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M20.378,18.147l.387.29a.274.274,0,0,0,.116.039.151.151,0,0,0,.136-.058l.406-.406a.182.182,0,0,0,.019-.251l-.31-.387a1.907,1.907,0,0,0,.232-.581l.484-.058a.206.206,0,0,0,.175-.194V15.96a.206.206,0,0,0-.175-.194l-.484-.058a3.569,3.569,0,0,0-.232-.581l.291-.387a.207.207,0,0,0-.019-.271l-.387-.426a.183.183,0,0,0-.252-.019l-.387.31A1.924,1.924,0,0,0,19.8,14.1l-.058-.484a.205.205,0,0,0-.194-.174h-.581a.206.206,0,0,0-.194.174l-.058.484a3.648,3.648,0,0,0-.581.232l-.387-.31a.181.181,0,0,0-.251.019l-.406.426a.182.182,0,0,0-.019.251l.31.387a1.935,1.935,0,0,0-.232.581l-.523.058a.206.206,0,0,0-.174.194v.581a.206.206,0,0,0,.174.194l.484.058a3.611,3.611,0,0,0,.232.581l-.31.387a.182.182,0,0,0,.019.252l.406.425a.182.182,0,0,0,.252.019l.387-.31a1.924,1.924,0,0,0,.581.232l.058.484a.206.206,0,0,0,.194.174h.581a.206.206,0,0,0,.194-.174l.058-.484a1.8,1.8,0,0,0,.619-.213",
    transform: "translate(-5.886 -4.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M21.384,19.351l.486.365a.345.345,0,0,0,.146.049.19.19,0,0,0,.17-.073l.511-.51a.228.228,0,0,0,.024-.316l-.389-.486a2.4,2.4,0,0,0,.292-.73l.608-.073a.259.259,0,0,0,.219-.243V16.6a.259.259,0,0,0-.219-.243l-.608-.073a4.482,4.482,0,0,0-.292-.729l.365-.486a.261.261,0,0,0-.024-.34l-.486-.535a.23.23,0,0,0-.316-.024l-.486.389a2.417,2.417,0,0,0-.729-.292l-.073-.608a.258.258,0,0,0-.243-.219h-.729a.258.258,0,0,0-.243.219l-.073.608a4.582,4.582,0,0,0-.73.292l-.486-.389a.227.227,0,0,0-.316.024l-.511.535a.229.229,0,0,0-.024.316l.389.486a2.43,2.43,0,0,0-.292.729l-.656.073a.258.258,0,0,0-.219.243v.729a.258.258,0,0,0,.219.243l.608.073a4.535,4.535,0,0,0,.291.729l-.389.486a.228.228,0,0,0,.024.316l.511.534a.229.229,0,0,0,.316.024l.486-.389a2.417,2.417,0,0,0,.729.292l.073.608a.258.258,0,0,0,.243.219h.73a.258.258,0,0,0,.243-.219l.073-.608A2.255,2.255,0,0,0,21.384,19.351Z",
    transform: "translate(-6.599 -5.093)",
    fill: "#fff",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M20.943,16.8a1.133,1.133,0,1,0,1.141,1.133A1.141,1.141,0,0,0,20.943,16.8",
    transform: "translate(-7.566 -6.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.141,
    cy: 1.133,
    rx: 1.141,
    ry: 1.133,
    transform: "translate(12.236 10.737)",
    fill: "none",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/User Management.9a53f86f7337e384958af19f171b9184.svg";
export { ForwardRef as ReactComponent };